module.exports = __webpack_public_path__ + "static/media/icon5.75002a65.svg";